import { filter, map, Observable, pipe, UnaryFunction } from 'rxjs';

export type OriginType = 'EMANAGER-RFT';

export interface PushData {
  entity: PushType;
  itemId: number;
  action: PushAction;
  originType?: OriginType;
  value?: unknown;
}

export type PushType =
  | 'BROADCASTING_PROGRAM'
  | 'CONTACT'
  | 'HEADQUARTER'
  | 'HEADQUARTER_PROFESSIONAL'
  | 'HEADQUARTER_PUBLICATION'
  | 'MATERIAL'
  | 'MESSAGING'
  | 'NOTE'
  | 'OFFER'
  | 'PLANNING'
  | 'PROFESSIONAL'
  | 'PUBLICATION'
  | 'RESIDENT_CONTACT'
  | 'RESIDENT'
  | 'ROOM'
  | 'SERVICE_NOTE'
  | 'TEAM'
  | 'TV_PACKAGE'
  | 'TV_CHANNEL'
  | 'WEB_RADIO';

export type PushAction =
  | 'UPSERT'
  | 'CREATE'
  | 'ATTACH'
  | 'CHANGE_ROOM'
  | 'DETACH'
  | 'DETACH_HEADQUARTER'
  | 'DETACH_OFFER'
  | 'LEAVE_OFFER'
  | 'LEAVE_ROOM'
  | 'MOVE'
  | 'DELETE'
  | 'END_BROADCASTING'
  | 'NEW_MESSAGE'
  | 'NEW_MESSAGE_GROUP'
  | 'START_SCAN'
  | 'END_SCAN';

export function ofPushType<T extends PushData>(
  pushType: PushType,
  pushAction: PushAction
): UnaryFunction<Observable<PushData>, Observable<T>>;
export function ofPushType<T extends PushData>(
  pushType: PushType[],
  pushAction: PushAction
): UnaryFunction<Observable<PushData>, Observable<T>>;
export function ofPushType<T extends PushData>(
  pushType: PushType,
  pushAction: PushAction[]
): UnaryFunction<Observable<PushData>, Observable<T>>;
export function ofPushType<T extends PushData>(
  pushType: PushType[],
  pushAction: PushAction[]
): UnaryFunction<Observable<PushData>, Observable<T>>;

export function ofPushType<T extends PushData>(
  pushType: PushType | PushType[],
  pushAction: PushAction | PushAction[]
): UnaryFunction<Observable<PushData>, Observable<number | T>> {
  const pushTypes = Array.isArray(pushType) ? pushType : [pushType];
  const pushActions = Array.isArray(pushAction) ? pushAction : [pushAction];
  return pipe(
    filter(
      (push: PushData) =>
        pushTypes.includes(push.entity) && pushActions.includes(push.action) && push.originType === 'EMANAGER-RFT'
    ),
    map((push) => {
      if (typeof push.value === 'string') {
        return {
          ...push,
          value: JSON.parse(push.value),
        };
      }
      return push;
    }),
    map((push) => push as T)
  );
}
